import RecommendedTopics from "./RecommendedTopics";

export default RecommendedTopics;
